import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Saml, SamlState, SamlTypes } from './types';

const INITIAL_STATE: SamlState = {
    data: {} as Saml,
    loading: false,
    hasError: false,
    success: false,
};

const reducer: Reducer<SamlState> = (state: SamlState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case SamlTypes.SAML_REQUEST:
            return { ...state, loading: true };
        case SamlTypes.SAML_SUCCESS:
            return {
                ...state,
                loading: true,
                data: { ...action.payload.data },
            };
        case SamlTypes.SAML_FAILURE:
            return { ...state, hasError: true, loading: false, error: { ...action.payload } };

        default:
            return state;
    }
};

export default reducer;
